import { Injectable } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import { Observable } from 'rxjs'

export interface HasUnsavedChanges {
  hasUnsavedChanges: boolean
  showUnsavedChangesDialog(): Observable<boolean> | Promise<boolean> | boolean
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<HasUnsavedChanges> {
  canDeactivate(component: HasUnsavedChanges): Observable<boolean> | Promise<boolean> | boolean {
    if (component.hasUnsavedChanges) {
      return component.showUnsavedChangesDialog()
    }
    return true
  }
}
